import React from 'react'
import { LikertLegend, TableWrapper, multiSelectionBars } from 'react-likert'
import * as renderers from './tables'
import { D3Context } from './tables'

const renderOptionDefaults = {
  Single: { diverging: false, usePatterns: false, maxBarHeight: 20 },
  Matrix: { diverging: false, usePatterns: false, maxBarHeight: 20 },
  Multi: {  }
}

const withDefaults = ({ options, renderer }) => (
  renderer==='Multi'
    ? {
        options: {
          ...renderOptionDefaults[renderer],
          ...options,
        },
        renderer: multiSelectionBars,
      }
    : {
        options: 
        {
          ...renderOptionDefaults[renderer],
          ...options,
        }
      }
)

const LegendOpts = { inline: true, size: 12 }

const LikertWrapper = ({ Q, route, data }) => (
  <TableWrapper scale={Q.multi ? undefined : Q.choices} {...withDefaults(Q)}>
    {CellRenderer => 
      <D3Context.Provider 
        value={{ 
          CellRenderer,
          HeaderRenderer: () => 
            <LikertLegend 
              scale={Q.choices} 
              options={withDefaults(Q).options}
              {...LegendOpts}
            />
        }}
      >
        {React.cloneElement(renderers[Q.renderer](route, Q), {data})}
      </D3Context.Provider>
    }
  </TableWrapper>
)

export const JustHeader = ({ Q }) => (
  <div>x</div>
  /*<LikertLegend
    scale={Q.choices} 
    options={withDefaults(Q)}
    {...LegendOpts}
  />*/
)

export default LikertWrapper
